// extracted by mini-css-extract-plugin
export default {"-large":"txmvq_0uQdxyRGNV2Vnd","listItem":"ZzDw7V4YJW6euWOZHCQM","customListItem":"nmcNX65yhHruzQaNQa97"};